function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.54,14.07a13.37,13.37,0,0,1-5.5,5.3V25.7a.75.75,0,0,1-.33.62l-4.5,3a.74.74,0,0,1-.42.13A.76.76,0,0,1,13,28.7V19.37a13.37,13.37,0,0,1-5.5-5.3,15.76,15.76,0,0,1-2-8.13,1.28,1.28,0,0,1-.09-.44c0-2.87,9.47-2.95,10.55-2.95s10.45.08,10.54,2.91h0v0h0A15.94,15.94,0,0,1,24.54,14.07ZM7,5.5C7.59,6.06,10.83,7,16,7s8.39-.89,9-1.45c-.6-.56-3.84-1.45-9-1.45S7.59,4.94,7,5.5ZM25,7.18C22.31,8.4,16.8,8.45,16,8.45S9.8,8.4,7.05,7.22a14.45,14.45,0,0,0,1.79,6.11,11.82,11.82,0,0,0,5.27,4.89.76.76,0,0,1,.43.68v8.4l3-2V18.9a.76.76,0,0,1,.43-.68,11.82,11.82,0,0,0,5.27-4.89A14.38,14.38,0,0,0,25,7.18Z",
  fill: "#33ba69"
});

var SvgFilterIcon = function SvgFilterIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilterIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter_icon.54d56a1f.svg";
export { ForwardRef as ReactComponent };